<template>
  <div
    :class="`status-badge status-badge__${status} rounded-full w-2.5 h-2.5 me-1 inline-flex flex-shrink-0`"
  />
</template>
<script>
export default {
  props: {
    status: { type: String, default: '' },
  },
};
</script>
<style lang="scss" scoped>
.status-badge {
  // `accent-mint` rather than the fixed brand mint: as a 10px dot this is a meaningful graphic,
  // and pure mint on a light ground sits at 1.4:1. The theme-aware pair keeps it readable in
  // both modes and still reads as the brand's "alive" colour on dark, which is where it lives.
  &__online {
    @apply bg-accent-mint;
  }

  &__offline {
    @apply bg-slate-500;
  }

  &__busy {
    @apply bg-yellow-500;
  }
}
</style>
